import script from "./CandidateSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateSlider.vue?vue&type=script&setup=true&lang=js"

import "./CandidateSlider.vue?vue&type=style&index=0&id=7e6631a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e6631a4"]])

export default __exports__